import React, { Fragment, useState } from "react";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Image,
  Table,
  Alert,
  FormGroup,
} from "react-bootstrap";
import { Elements } from "react-stripe-elements";

import BillingDetailsFields from "./prebuilt/BillingDetailsFields";
// import SubmitButton from "./prebuilt/SubmitButton";
// import CheckoutError from "./prebuilt/CheckoutError";

const CheckoutForm = ({ disabled, getToken }) => {
  const [isProcessing, setProcessingTo] = useState(false);
  const [checkoutError, setCheckoutError] = useState();

  const stripe = useStripe();
  const elements = useElements();

  const handleCardDetailsChange = (ev) => {
    ev.error ? setCheckoutError(ev.error.message) : setCheckoutError();
  };

  const handleFormSubmit = async (ev) => {
    ev.preventDefault();
    setProcessingTo(true);

    const billingDetails = {
      name: ev.target.name.value,
      address_zip: ev.target.zip.value,
    };

    const cardElement = elements.getElement("card");

    const { token, error } = await stripe.createToken(
      cardElement,
      billingDetails
    );

    if (error) {
      setCheckoutError(error.message);
      setProcessingTo(false);
      return;
    }
    getToken(token);
  };

  const iframeStyles = {
    base: {
      color: "#000",
      border: "solid",
      fontSize: "16px",
      iconColor: "#bb9841",
      "::placeholder": {
        color: "#87bbfd",
      },
    },
    invalid: {
      iconColor: "#FFC7EE",
      color: "#FFC7EE",
    },
    complete: {
      iconColor: "#cbf4c9",
    },
  };

  const cardElementOpts = {
    iconStyle: "solid",
    style: iframeStyles,
    hidePostalCode: true,
  };

  return (
    <Fragment>
      <Form onSubmit={handleFormSubmit} className="chekZipcode stripe-card">
        <Row>
          <Col md="12" xs="12">
            <div class="form-group">
              <label>Name on Card </label>
              <br />
              <input name="name" type="text" placeholder="Jane Doe" required />
            </div>
          </Col>
          <Col md="12" xs="12">
            <div class="form-group">
              <label>Zipcode/Postal Code </label>
              <br />
              <input name="zip" type="text" placeholder="123456" required />
            </div>
          </Col>
        </Row>
        <Row>
          <Col md="12" xs="12">
            <div class="form-group">
              <label>Card </label>
              <CardElement
                options={cardElementOpts}
                onChange={handleCardDetailsChange}
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col>{checkoutError && <p>{checkoutError}</p>}</Col>
        </Row>
        <Row>
          <Col md="12" xs="12">
            <Button
              variant="raised"
              color="primary"
              type="submit"
              className="order-pay"
              disabled={disabled || isProcessing || !stripe}
            >
              <h5>{isProcessing ? "Processing..." : `SUBMIT PAYMENT`}</h5>
            </Button>
          </Col>
        </Row>
      </Form>
    </Fragment>
  );
};

export default CheckoutForm;
